module.exports = __webpack_public_path__ + "img/logo_black@2x.3e2677fd.png";